/**
 * @generated SignedSource<<bc34188bf84d99dae56bcc78fda39cd1>>
 * @relayHash c02ba950f692b1f80e029983d5f0af2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9a5a3b7ce324dbfb2e2ffecbdd57a405fbd426427f92c67d4f4c2e2efddbc289

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null | undefined;
  board?: JiraJqlBoardInput | null | undefined;
  list?: JiraIssueSearchScope | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
  project?: JiraJqlProjectInput | null | undefined;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type JiraJqlProjectInput = {
  projectKey?: string | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery$variables = {
  cloudId: string;
  isFilterRefinementEnabled: boolean;
  scope?: JiraJqlScopeInput | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement">;
  } | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery = {
  response: JQLBuilderWithAIFilterRefinementQuery$data;
  variables: JQLBuilderWithAIFilterRefinementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isFilterRefinementEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scope"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "FilterRefinement"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                      },
                      {
                        "kind": "Literal",
                        "name": "jqlTerm",
                        "value": "assignee"
                      },
                      (v2/*: any*/)
                    ],
                    "concreteType": "JiraJqlFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "fieldValues",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraJqlFieldValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "id"
                                      }
                                    ]
                                  }
                                ],
                                "type": "JiraJqlUserFieldValue"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9a5a3b7ce324dbfb2e2ffecbdd57a405fbd426427f92c67d4f4c2e2efddbc289",
    "metadata": {},
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "37fa794ea958dbaf63438e6288b42c68";

export default node;
